import type { SepayCheckoutForm } from '../services/payment.api';

/** The SePay hosted checkout expects a browser form POST with the server-signed fields. */
export function submitCheckoutForm(checkout: SepayCheckoutForm): void {
  const form = document.createElement('form');
  form.method = 'POST';
  form.action = checkout.url;
  form.style.display = 'none';
  for (const field of checkout.fields) {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = field.name;
    input.value = field.value;
    form.appendChild(input);
  }
  document.body.appendChild(form);
  form.submit();
}
